import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishContent from "./en";

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    resources: {
        en: {
            translation: englishContent
        }
    },
    interpolation: {
        escapeValue: false
    }
})